import React from 'react';
import clsx from 'clsx';
import styles from './ChangeTrackButton.module.scss';
import AppTooltip from '../../../../../components/shared/AppTooltip';
import { changeTrack } from '../utils';

const ChangeTrackButton = ({ text, value, tooltip }) => (
  <div className={styles.changeTrackWrapper}>
    <button
      type="button"
      id="eap-link"
      data-tip
      data-for="change-track-tooltip"
      className={clsx('btn-plain', styles.btnChangeTrack)}
      onClick={() => changeTrack(value)}
    >
      {text}
      <span className={styles.iconWrapper}>
        <i className="material-symbols-outlined" style={{ fontSize: 18 }}>
          info
        </i>
      </span>
    </button>
    <AppTooltip id="change-track-tooltip" effect="solid">
      <div className={clsx(styles.changeTrackTooltip, styles[value])}>
        {tooltip}
      </div>
    </AppTooltip>
  </div>
);

export default ChangeTrackButton;
